import styled, { css } from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledDropdownItemText = styled.span`
    ${mixins.setFontVariant("report", colorsPalettes.carbon["500"])};

    line-height: 44px;
`;

export const StyledDropdownItem = styled.div<{ isDisabled: boolean; isSelected: boolean }>`
    background-color: ${({ isSelected }) => (isSelected ? colorsPalettes.bluegrey["100"] : colorsPalettes.carbon["0"])};
    box-sizing: border-box;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    height: 44px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${({ isDisabled }) =>
        isDisabled
            ? css`
                  & ${StyledDropdownItemText} {
                      color: ${colorsPalettes.carbon["100"]};
                  }
              `
            : css`
                  &:hover {
                      background-color: ${colorsPalettes.carbon["25"]};
                  }
              `};
`;
